module.exports = __webpack_public_path__ + "img/caret-down-fill.0d902c53.svg";